import { ChangeEvent, FC, memo, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useSearchParams } from 'react-router-dom'

import s from './Search.module.scss'

import { SearchIcon } from 'assets/icons/SearchIcon'

import { InputControlled } from 'components/Controls/Input/InputControlled'

interface SearchProps {
  getValueFromServer?: (value: string) => void
  paramPrefix: string
  className?: string
  onFocus?: () => void
  onBlur?: () => void
}

const Search: FC<SearchProps> = memo((props: SearchProps) => {
  const { getValueFromServer, paramPrefix, className, onFocus, onBlur } = props
  const [searchParams, setSearchParams] = useSearchParams()

  const searchQuery = searchParams.get(`s__${paramPrefix}`) || ''

  const { control, setValue, setFocus, watch } = useForm({
    mode: 'onChange',
    defaultValues: {
      search: '',
    },
  })

  useEffect(() => {
    if (searchQuery.length) {
      setValue('search', searchQuery)
      setFocus('search')
      if (getValueFromServer !== undefined) getValueFromServer(searchQuery.trim().toLowerCase())
    }
  }, [])

  const searchVal = watch('search')

  useEffect(() => {
    if (searchVal?.length) {
      setSearchParams({ ...Object.fromEntries(searchParams), [`s__${paramPrefix}`]: searchVal })
    } else {
      searchParams.delete(`s__${paramPrefix}`)
      setSearchParams(searchParams)
    }
  }, [searchVal])

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const searchValue = e.target.value
    setValue('search', searchValue)
    if (getValueFromServer !== undefined) getValueFromServer(searchValue.trim().toLowerCase())
  }

  return (
    <InputControlled
      icon={<SearchIcon />}
      control={control}
      name="search"
      error={undefined}
      customOnChange={handleInputChange}
      placeholder="Search..."
      wrapperClassName={`${s.search} ${className}`}
      onFocus={onFocus}
      onBlur={onBlur}
    />
  )
})

export default Search
